export const pairing = {
  intro:
    "Connect your partner's phone so feedings, diapers, and everything else show up on both phones automatically.",
  createInvite: 'Create invite',
  creating: 'Creating invite…',

  inviteTitle: 'Your invite code',
  showInvite: 'Show invite code',
  hideInvite: 'Hide invite code',
  scanHint: "On your partner's phone, scan this with the camera, or type the code during setup.",
  keyWarning:
    'This code is also the key that protects your data. Share it directly with your partner and no one else.',
  shareLink: 'Share invite link',
  copyLink: 'Copy invite link',
  copied: 'Link copied!',
  qrAlt: 'Invite code as a QR code',

  enterHint: 'Ask mom to open Settings, then Partner connection, and tap Create invite.',
  codeLabel: 'Invite code',
  codePlaceholder: 'XXXX-XXXX-XXXX-XXXX',
  connect: 'Connect',
  connecting: 'Connecting…',

  connectedSince: (date: string) => `Connected since ${date}`,
  syncNow: 'Sync now',
  disconnect: 'Disconnect',
  disconnectWarning:
    'Syncing will stop, but nothing is deleted. All entries stay on both phones.',
  confirmDisconnect: 'Yes, disconnect',

  errors: {
    invalidCode: 'That code does not look complete. It has 16 letters and numbers.',
    unreachable: 'We could not reach the sync service. Check your internet connection and try again.',
    joinFailed: 'That did not work. Double-check the code and try again.',
    createFailed: 'We could not create the invite. Check your internet connection and try again.',
  },
};
